export namespace Uuid {
    function fallback(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    export function create(): string {
        if ('crypto' in self) {
            return crypto.randomUUID();
        } else {
            return fallback();
        }
    }
}
